'use client';

import { forwardRef } from 'react';
import type { StackProps as MantineStackProps } from '@mantine/core';
import { Stack as MantineStack } from '@mantine/core';

export type StackProps = MantineStackProps;

export const Stack = forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  return <MantineStack {...props} ref={ref} />;
});

Stack.displayName = 'Stack';
